module.exports = __webpack_public_path__ + "static/media/Sahil Lamba.03829338.png";